import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPieChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.595 1.115a11.007 11.007 0 0 1 9.29 9.29c.07.475.104.712.008.957a1.088 1.088 0 0 1-.44.509c-.229.13-.503.13-1.053.13h-7.8c-.56 0-.84 0-1.054-.11a1 1 0 0 1-.437-.437C12 11.24 12 10.96 12 10.4V2.6c0-.55 0-.824.13-1.053.103-.184.311-.364.508-.44.245-.096.483-.061.957.008Z"
    />
    <path
      fill="currentColor"
      d="M10 3.102c0-.638 0-.957-.163-1.206a1.096 1.096 0 0 0-.618-.43c-.29-.064-.55.033-1.068.226C3.974 3.252 1 7.28 1 12c0 6.075 4.925 11 11 11 4.721 0 8.747-2.974 10.308-7.15.194-.52.29-.779.225-1.07a1.096 1.096 0 0 0-.429-.617C21.855 14 21.536 14 20.898 14h-7.344c-.239 0-.523 0-.774-.02a3.014 3.014 0 0 1-1.142-.307 3 3 0 0 1-1.311-1.311 3.015 3.015 0 0 1-.307-1.142c-.02-.25-.02-.535-.02-.774V3.102Z"
    />
  </svg>
);
SvgPieChart01.displayName = 'PieChart01';
export default SvgPieChart01;
